export default {"src":"/_next/static/media/concierge-support.be0d9b26.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};